var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50016 0.333313C3.98516 0.333313 0.333496 3.98498 0.333496 8.49998C0.333496 14.625 8.50016 23.6666 8.50016 23.6666C8.50016 23.6666 16.6668 14.625 16.6668 8.49998C16.6668 3.98498 13.0152 0.333313 8.50016 0.333313ZM2.66683 8.49998C2.66683 5.27998 5.28016 2.66665 8.50016 2.66665C11.7202 2.66665 14.3335 5.27998 14.3335 8.49998C14.3335 11.86 10.9735 16.8883 8.50016 20.0266C6.0735 16.9116 2.66683 11.825 2.66683 8.49998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50016 11.4166C10.111 11.4166 11.4168 10.1108 11.4168 8.49998C11.4168 6.88915 10.111 5.58331 8.50016 5.58331C6.88933 5.58331 5.5835 6.88915 5.5835 8.49998C5.5835 10.1108 6.88933 11.4166 8.50016 11.4166Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.3346e6c474a968088cd0eee100dc2a00.svg";
export { ForwardRef as ReactComponent };